import fetch from '@/api/fetch'

/**
 * 获取海报分享图片
 * @param {Object} params - 包含spuId、skuId属性.
 */
export function getPosterInfo(params) {
  return fetch({
    url: '/commodityPoster/getPosterInfo',
    params
  })
}


/**
 * 获取推荐购机分享配置
 */
export function getRecommendConfig() {
  return fetch({
    url: '/recmmdPurchase/getConfig'
  })
}

/**
 * 获取推荐购机分享配置
 */
export function queryPosterCmdDetail(params) {
  return fetch({
    url: '/commodityPoster/queryCommodityDetail',
    params
  })
}

/**
 * 分享卡片接口
 * @param {Object} params
 */
export function sharePosterWx(params) {
  return fetch({
    url: '/commodityPoster/wxMiniQrCode',
    unLogin: true,
    params
  })
}
/**
 * 推荐活动分享信息接口
 * @param {Object} params
 */

export function getActivityShareMsg() {
  return fetch({
    method: 'post',
    url: '/share/award/shareContent'
  })
}